module.exports = __webpack_public_path__ + "static/media/bluePlanet.a5eeae1d.svg";